import Vue from 'vue';
import Vuex from 'vuex';
import payment from './modules/payment';
import notification from './modules/notification';
import ui from './modules/ui';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    payment,
    notification,
    ui,
  },
});
